(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["schnapskartell-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseSchnapskartellReach = () => {
      document.querySelectorAll('[data-sk-suggest-select]').forEach((requestType) => {
        if (requestType.dataset.skSuggestSelectReady === 'true') return;
        requestType.dataset.skSuggestSelectReady = 'true';

        const form = requestType.closest('form');
        const placeField = form?.querySelector('[data-sk-suggest-place]');
        const messageField = form?.querySelector('[data-sk-suggest-message]');
        const syncSuggestionFields = () => {
          const isSuggestion = requestType.value === requestType.dataset.suggestValue;
          if (placeField) placeField.required = isSuggestion;
          if (!messageField) return;
          messageField.required = !isSuggestion;
          messageField.placeholder = isSuggestion
            ? messageField.dataset.suggestPlaceholder
            : messageField.dataset.defaultPlaceholder;
        };

        requestType.addEventListener('change', syncSuggestionFields);
        syncSuggestionFields();
      });

      document.querySelectorAll('[data-sk-suggest-link]').forEach((link) => {
        if (link.dataset.skSuggestReady === 'true') return;
        link.dataset.skSuggestReady = 'true';

        link.addEventListener('click', () => {
          const formSection = document.querySelector(link.getAttribute('href'));
          const requestType = formSection?.querySelector('[data-sk-suggest-select]');
          const placeField = formSection?.querySelector('[data-sk-suggest-place]');

          if (requestType?.dataset.suggestValue) {
            requestType.value = requestType.dataset.suggestValue;
            requestType.dispatchEvent(new Event('change', { bubbles: true }));
          }

          window.setTimeout(() => placeField?.focus({ preventScroll: true }), 420);
        });
      });

      document.querySelectorAll('[data-sk-share]').forEach((button) => {
        if (button.dataset.skShareReady === 'true') return;

        const canShare = typeof navigator.share === 'function';
        const canCopy = window.isSecureContext && typeof navigator.clipboard?.writeText === 'function';
        if (!canShare && !canCopy) return;

        button.dataset.skShareReady = 'true';
        button.hidden = false;

        button.addEventListener('click', async () => {
          const status = button.parentElement?.querySelector('[data-sk-share-status]');
          const payload = {
            title: button.dataset.shareTitle,
            text: button.dataset.shareText,
            url: button.dataset.shareUrl,
          };

          if (status) status.textContent = '';

          try {
            if (canShare && (!navigator.canShare || navigator.canShare(payload))) {
              await navigator.share(payload);
              return;
            }

            if (canCopy) {
              await navigator.clipboard.writeText(payload.url);
              if (status) status.textContent = button.dataset.shareCopied;
              return;
            }
          } catch (error) {
            if (error?.name === 'AbortError') return;

            if (canCopy) {
              try {
                await navigator.clipboard.writeText(payload.url);
                if (status) status.textContent = button.dataset.shareCopied;
                return;
              } catch (copyError) {
                // The status below is the accessible fallback when both paths fail.
              }
            }
          }

          if (status) status.textContent = button.dataset.shareError;
        });
      });
    };

    initialiseSchnapskartellReach();
    document.addEventListener('shopify:section:load', initialiseSchnapskartellReach);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-stream"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('asif-social-gallery')) {
  customElements.define('asif-social-gallery', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      this.track = this.querySelector('.social-stream__track');
      this.controls = this.querySelector('[data-social-controls]');
      this.previous = this.querySelector('[data-social-previous]');
      this.next = this.querySelector('[data-social-next]');
      this.status = this.querySelector('[data-social-status]');
      this.fallback = this.querySelector('[data-social-fallback]');
      if (!this.track) return;
      const options = {signal: this.lifecycle.signal};
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), {...options, passive: true});
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      if (this.track.childElementCount) { this.update(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, {rootMargin: '500px 0px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.request?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
    }
    async load() {
      this.request = new AbortController();
      const timeout = setTimeout(() => this.request.abort(), 10000);
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.endpoint, {credentials: 'omit', referrerPolicy: 'no-referrer', signal: this.request.signal});
        if (!response.ok) throw Error('Gallery unavailable');
        const payload = await response.json();
        if (!Array.isArray(payload.data)) throw Error('Invalid gallery');
        const posts = payload.data.filter(post => {
          try {
            const image = new URL(post.media_url);
            const link = new URL(post.permalink);
            return image.origin === 'https://social.as-if-records.com'
              && /^\/media\/\d{8,30}$/.test(image.pathname)
              && link.origin === 'https://www.instagram.com'
              && /^\/(p|reel)\/[\w-]+\/?$/.test(link.pathname);
          } catch { return false; }
        }).filter((post,index,all) => all.findIndex(item => item.id === post.id) === index).slice(0,6);
        if (!posts.length) throw Error('Empty gallery');
        const fragment = document.createDocumentFragment();
        for (const [index,post] of posts.entries()) {
          const item = this.querySelector('[data-social-card]').content.cloneNode(true);
          const link = item.querySelector('a');
          const image = item.querySelector('img');
          const caption = String(post.caption || '').replace(/\s+/g, ' ').trim().slice(0,160);
          link.href = post.permalink;
          link.setAttribute('aria-label', `${this.dataset.itemLabel} ${index + 1} / ${posts.length}. ${caption} ${this.dataset.newTabLabel}`);
          image.src = post.media_url;
          image.addEventListener('error', () => { image.hidden = true; this.fallback.hidden = false; }, {once: true});
          item.querySelector('.social-stream__index').textContent = String(index + 1).padStart(2,'0');
          fragment.append(item);
        }
        if (!this.isConnected) return;
        this.track.replaceChildren(fragment);
        this.track.style.setProperty('--social-visible-count', String(posts.length));
        this.track.hidden = false;
        this.fallback.hidden = true;
        this.update();
      } catch {
        if (this.isConnected) this.fallback.hidden = false;
      } finally {
        clearTimeout(timeout);
        this.setAttribute('aria-busy', 'false');
      }
    }
    move(direction) {
      const step = this.track.firstElementChild?.getBoundingClientRect().width || this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({left: direction * (step + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    update() {
      const items = [...this.track.children];
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.controls.hidden = !overflow || !items.length;
      if (!overflow || !items.length) return;
      const bounds = this.track.getBoundingClientRect();
      const visible = items.map((item,index) => ({rect: item.getBoundingClientRect(),index})).filter(item => item.rect.right > bounds.left + 20 && item.rect.left < bounds.right - 20);
      this.status.textContent = `${(visible[0]?.index || 0) + 1}-${(visible.at(-1)?.index || 0) + 1} / ${items.length}`;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
